var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-control"},[_c('span',{staticClass:"settings-control__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"settings-control__content",class:_vm.contentClasses},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }